import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountUtils, DateUtils } from '@shared/utils';
import type { StatementsResponse } from '@shared/api';
import { Button, Icon, Spinner, Table, TableCellType } from '@shared/widgets';
import DownloadIcon from '@assets/icons/download.svg';

interface ConsolidateTableProps {
  isLoading?: boolean;
  error?: string | null;
  statements: StatementsResponse[];
  downloadingIds: string[];
  onDownloadStatement: (statement: StatementsResponse) => void;
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
  onRefresh?: () => void;
}

export const ConsolidateTable = (props: ConsolidateTableProps) => {
  const { t } = useTranslation('statements');

  const columns = useMemo(() => [t('card.consolidated.columns.date'), t('card.consolidated.columns.balanceDue')], [t]);
  return (
    <Table
      isScrollable
      isLoading={props.isLoading}
      error={props.error}
      onRefresh={props.onRefresh}
      columns={columns}
      items={props.statements.map((x) => {
        const isLoading = props.downloadingIds.includes(x.statementId);
        return [
          {
            key: `date-${x.statementId}`,
            type: TableCellType.Text,
            value: DateUtils.formatDate(x.date),
          },
          {
            key: `balance-${x.statementId}`,
            type: TableCellType.Text,
            value: AmountUtils.transformToAmountWithCurrency(x.balanceDue, x.currency),
          },
          {
            key: `download-${x.statementId}`,
            type: TableCellType.Custom,
            value: (
              <Button className='w-[52px]' color='icon' disabled={isLoading} onClick={() => props.onDownloadStatement(x)}>
                {isLoading ? <Spinner embedded /> : <Icon icon={<DownloadIcon />} />}
              </Button>
            ),
          },
        ];
      })}
      pagination={{
        totalItemCount: props.totalItemCount,
        currentPage: props.currentPage,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
